import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import PropertyGrid from '../components/PropertyGrid';
import { Switch } from '@headlessui/react';
import PageWrapper from '../components/layout/PageWrapper';

const StaysPage: React.FC = () => {
  const [showMap, setShowMap] = useState(false);

  return (
    <PageWrapper withSearchBar>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center gap-8">
            <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-full transition-colors">
              Cancellation flexibility
            </button>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-full transition-colors">
              Type of place
            </button>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-full transition-colors">
              Price
            </button>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-full transition-colors">
              More filters
            </button>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">Show map</span>
            <Switch
              checked={showMap}
              onChange={setShowMap}
              className={`${
                showMap ? 'bg-airbnb-red' : 'bg-gray-200'
              } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-airbnb-red focus:ring-offset-2`}
            >
              <span
                className={`${
                  showMap ? 'translate-x-6' : 'translate-x-1'
                } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
              />
            </Switch>
          </div>
        </div>

        <div className="mt-4">
          <h1 className="text-2xl font-semibold text-gray-900">
            300+ stays in selected area
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Review COVID-19 travel restrictions before you book.
          </p>
        </div>

        <div className="mt-6">
          <PropertyGrid />
        </div>
      </div>
    </PageWrapper>
  );
};

export default StaysPage;